import type { App } from "vue";
import axios from "axios";
import JwtService from "@/core/services/JwtService";
import { ApiClient } from "@/core/services/ApiClient";
import moment from "moment";
import { isConstructorDeclaration } from "typescript";

class ApiService {
  public static apiClient: ApiClient;
  public static isInited: boolean;

  private static isValidDateString(value: any): boolean {
    if (typeof value !== "string") {
      return false;
    }
    // Kiểm tra các định dạng ngày tháng phổ biến
    const formats = [
      moment.ISO_8601,
      "YYYY-MM-DD",
      "YYYY-MM-DD HH:mm:ss",
      "YYYY-MM-DDTHH:mm:ssZ",
      "DD-MM-YYYY",
      "DD/MM/YYYY",
      "MM/DD/YYYY",
      // Thêm các định dạng khác nếu cần
    ];
    return moment(value, formats, true).isValid();
  }
  private static convertDatesToISOString(data: any | null | undefined): any {
    if (Array.isArray(data)) {
      return data.map((item) => this.convertDatesToISOString(item));
    } else if (typeof data === "object" && data !== null) {
      const result: any = { ...data };

      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];
          if (key == "startDate") {
          }
          if (!value) result[key] = value;
          else if (Array.isArray(value) || typeof value === "object") {
            result[key] = this.convertDatesToISOString(value);
          } else if (this.isValidDateString(value)) {
            result[key] = moment(value).format("YYYY-MM-DDTHH:mm:ss");
          }
        }
      }
      return result;
    }
    return data;
  }
  private static convertDatesToISO(data: any | null | undefined): any {
    if (Array.isArray(data)) {
      return data.map((item) => this.convertDatesToISO(item));
    } else if (typeof data === "object" && data !== null) {
      const result: any = { ...data };

      for (const key in data) {
        if (data.hasOwnProperty(key)) {
          const value = data[key];
          if (key == "startDate") {
          }
          if (!value) result[key] = value;
          else if (Array.isArray(value) || typeof value === "object") {
            result[key] = this.convertDatesToISO(value);
          } else if (this.isValidDateString(value)) {
            result[key] = moment(value).utcOffset(0);
          }
        }
      }
      return result;
    }
    return data;
  }

  public static init(app: App<Element>) {
    if (this.isInited) return;
    console.log("init api service");
    //queue for failed requests
    let isRefreshing = false;
    let failedQueue = [];
    const processQueue = (error, token = null) => {
      failedQueue.forEach((prom) => {
        if (error) {
          prom.reject(error);
        } else {
          prom.resolve(token);
        }
      });

      failedQueue = [];
    };
    // config default axios
    const config = useRuntimeConfig();
    const axiosInstance = axios.create({
      baseURL: config.public.apiBaseUrl,
      withCredentials: true,
    });
    axios.defaults.withCredentials = true;
    axiosInstance.defaults.withCredentials = true;
    axiosInstance.interceptors.request.use(
      (config) => {
        // Modify request config before sending the request
        const token = JwtService.getToken();
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
        config.withCredentials = true;

        if (
          config.method?.toLowerCase() === "post" ||
          config.method?.toLowerCase() === "put"
        ) {
          // Duyệt qua tất cả các thuộc tính của dữ liệu trong yêu cầu
          try {
            config.data = JSON.stringify(
              this.convertDatesToISOString(JSON.parse(config.data))
            );
          } catch (error) {}
        }

        return config;
      },
      (error) => {
        // Handle request error
        return Promise.reject(error);
      }
    );
    axiosInstance.interceptors.response.use(
      (response) => {
        // Handle successful response
        if (response.data) {
          try {
            // response.data = this.convertDatesToISO(response.data);
          } catch (error) {
            console.log(error);
          }
        }
        return response;
      },
      (error) => {
        const originalRequest = error.config;
        // Handle response error
        if (
          error.response &&
          error.response.status === 401 &&
          !originalRequest._retry
        ) {
          if (isRefreshing) {
            return new Promise((resolve, reject) => {
              failedQueue.push({ resolve, reject });
            })
              .then((token) => {
                originalRequest.headers["Authorization"] = "Bearer " + token;
                return axios(originalRequest);
              })
              .catch((err) => {
                return Promise.reject(err);
              });
          }
          originalRequest._retry = true;
          isRefreshing = true;
          return new Promise((resolve, reject) => {
            this.apiClient
              .refreshToken()
              .then((res) => {
                if (res.success && res.data && res.data.token) {
                  const token = res.data.token;
                  JwtService.saveToken(token);
                  axiosInstance.defaults.headers.Authorization = `Bearer ${token}`;
                  originalRequest.headers["Authorization"] = "Bearer " + token;
                  processQueue(null, token);
                  return resolve(axiosInstance(originalRequest));
                } else {
                  JwtService.destroyToken();
                  window.location.href = "/account/login";
                  return reject(error);
                }
              })
              .catch((err) => {
                processQueue(err, null);
                //window.location.href = '/account/login';
                //JwtService.destroyToken()
                return reject(err);
              })
              .then(() => {
                isRefreshing = false;
              });
          });
        } else {
          return Promise.reject(error);
        }
      }
    );
    this.apiClient = new ApiClient(config.public.apiBaseUrl, axiosInstance);
    this.isInited = true;
  }
}

export default ApiService;
